window.angular
    .module('MyHippoProducer')
    .directive('createPolicyBtn', function ($mdDialog, APIService, $state, FlagshipService, ReactRedirectService) {
        return {
            restrict: 'E',
            scope: {},
            template: `
            <div ng-hide="isBuilder">
                <a href="" ng-if="!shouldDisablePolicyCreation" class="btn btn-create" ng-click="redirectToReact()">
                    <img src='../../img/icon-plus.svg' alt="plus-icon"/>
                    GET QUOTE
                </a>
            </div>
        `,
            controller: function ($scope, $http, $log, UserService) {
                'ngInject';
                $scope.shouldDisablePolicyCreation = UserService.isPolicyCreationDisabled();
                $scope.isBuilder = UserService.isBuilder();

                $scope.redirectToReact = () => {
                    var bathPath = `v2/quote-flow/address`;
                    var baseUrl = ReactRedirectService.isLocalHost() ? `http://${ReactRedirectService.getLocationHostName()}:4000/` : './';
                    APIService.findAvailableOrganizationsForUser()
                        .then((organizations) => {
                            const availableOrganizationsToCreateFrom = organizations.filter(o => o.is_producer && o.disable_policy_creation !== true);
                            if (availableOrganizationsToCreateFrom.length > 1) {
                                return $mdDialog.show({
                                    template: `<mh-select-policy-creation-modal choices="orgChoices"></mh-select-policy-creation-modal>`,
                                    controller: function ($scope) { $scope.orgChoices = availableOrganizationsToCreateFrom; }
                                }).then(({id}) => {
                                    if (id) {
                                        const chosenOrg = availableOrganizationsToCreateFrom.find(o => o.id === result.id);
                                        const orgName = chosenOrg.name;
                                        var basePathWithOrgIdAndName = `${bathPath}?orgId=${result.id}&orgName=${orgName}`;
                                        window.location.href = `${baseUrl}${basePathWithOrgIdAndName}`;
                                    }
                                    // If no valid id, do nothing - user cancelled
                                });
                            } else {
                                window.location.href = `${baseUrl}${bathPath}`;
                            }
                        });
                };
            },
        };
    });
